import React from "react"

import { Carousel } from "react-bootstrap"

import CharacteristicsCard from "@/homeOwners/characteristicsCard"

function CharacteristicsCarousel(props) {
    return (
        <Carousel
            // controls={false}
            interval={null}
            variant="dark"
            className="p-0 d-sm-none"
        >
            <Carousel.Item>
                <CharacteristicsCard
                    icon="knowledge-icon.svg"
                    alt="Hands held out with a brain to signify knowledge"
                    title="Extensive local knowledge"
                    description={props.description1}
                />
            </Carousel.Item>
            <Carousel.Item>
                <CharacteristicsCard
                    icon="advice-icon.svg"
                    alt="Two people communicating, with one offering the other advice"
                    title="Expert advice"
                    description={props.description2}
                />
            </Carousel.Item>
            <Carousel.Item>
                <CharacteristicsCard
                    icon="standards-icon.svg"
                    alt="A ribbon with a star to signify award winning standards"
                    title="Professional standards"
                    description={props.description3}
                />
            </Carousel.Item>
            <Carousel.Item>
                <CharacteristicsCard
                    icon="respect-icon.svg"
                    alt="A heart icon where each side of the heart is represented shaking hands"
                    title="Communication & respect"
                    description={props.description4}
                />
            </Carousel.Item>
        </Carousel>
    )
}

export default CharacteristicsCarousel
